import config, { embeddedRuntime } from '@/config'
import { session } from '@/composables/useSession'

declare global {
  interface Window {
    __z2SunCoWidgetRef: any
    Z2SunCoWidget: any
  }
}

const getJWTTokenProxy = () =>
  fetch('/it-jwt/zendesk-sunco', {
    method: 'POST',
    headers: { 'X-CSRF-TOKEN': session.csrfToken },
  }).then((res) => res.json())

export function loadZ2SunCoWidget() {
  const Z2_SUNCO_WIDGET_URL = `https://static${config.zendeskDomain === 'zendesk.com' ? '' : '-staging'}.zdassets.com/z2-sunco-widget/z2-sunco-widget.js`

  if (embeddedRuntime() || !session.account) return

  const nonce = '__CSP_NONCE__'

  // Create the script element
  const widgetScript = document.createElement('script')
  widgetScript.setAttribute('nonce', nonce)
  widgetScript.async = true

  // Set the script and jwt sources based on the environment
  widgetScript.setAttribute('src', Z2_SUNCO_WIDGET_URL)

  // Configure the script's `onload` behavior
  widgetScript.onload = function () {
    console.info('[Z2SunCoWidget] | widgetScript - LOADING...')

    window.__z2SunCoWidgetRef = new window.Z2SunCoWidget({
      inProduct: true,
      resetAuth: true,
      jwtUrl: getJWTTokenProxy,
      position: {
        top: 'auto',
        right: '16px',
        bottom: '16px',
        left: 'auto',
      },
      orientation: 'right',
      openWidgetToNewConversation: false,
    })

    console.info('[Z2SunCoWidget] | widgetScript - DONE')
  }

  // Set the script source
  widgetScript.onerror = () => console.info('[Z2SunCoWidget] | ERROR while loading the script')

  // Append the script to the document head
  document.head.appendChild(widgetScript)
}
